
app.service("_$snackbar",function($mdBottomSheet){
   
    this.show=function(text){
        
        $mdBottomSheet.show({
            
            template: '<md-bottom-sheet>'+text+'</md-bottom-sheet>'
        
        });

    };
    
    
    
});


